import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { InputErrorMessageDictionary } from './input-error-message.dictionary';

@Component({
  selector: 'qaroni-input-error-message',
  standalone: true,
  imports: [],
  templateUrl: './input-error-message.component.html',
  styleUrl: './input-error-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputErrorMessageComponent {
  @Input() errors?: ValidationErrors | null = null;

  private dictionary = InputErrorMessageDictionary;

  get messages(): string[] {
    const keys = this.getKeys();

    return keys.map(this.mapper);
  }

  private getKeys() {
    return this.errors ? Object.keys(this.errors) : [];
  }

  private mapper = (key: string) => {
    if (Object.prototype.hasOwnProperty.call(this.dictionary, key)) {
      let message = this.dictionary[key];

      if (this.errors && typeof this.errors[key] === 'object') {
        message = this.replace(message, this.errors[key]);
      }

      return message;
    }

    return `Error: ${key}.`;
  };

  private replace(message: string, errorObject: ValidationErrors) {
    if (!(typeof errorObject === 'object')) {
      return message;
    }

    Object.keys(errorObject).forEach(key => {
      message = message.replaceAll(`{{ ${key} }}`, errorObject[key]);
    });

    return message;
  }
}
